import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { Url } from '../model/users.model';
import { Driver, Password, DriverJob, DriverFile } from '../model/driver.model';
import { State } from '../model/location.model';

@Injectable({
    providedIn: 'root'
})
export class DriversService {
    @LocalStorage() url: Url;


      private headers = new Headers({ 'Content-Type': 'application/json' });
    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    }
    constructor(public http:HttpClient) { 
    }

	getDrivers(): Observable<{drivers: Driver[]}> { 
        return this.http.get<{drivers: Driver[]}>(this.url.rest  + '/tms/getDrivers', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getDriver(id:number): Observable<Driver> { 
        return this.http.get<Driver>(this.url.rest  + '/tms/getDriver/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    // newer details
    getDriverDetails(id:number): Observable<Driver> { 
        return this.http.get<Driver>(this.url.rest  + '/tms/getDriverDetails/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }


    getDriversUsers(): Observable<Driver[]> { 
        return this.http.get<Driver[]>(this.url.rest  + '/tms/getDriversUsers', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    getJobsByDriver(id:number): Observable<DriverJob[]> { 
        return this.http.get<DriverJob[]>(this.url.rest  + '/tms/getJobsByDriver/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
        }
    
    createDriver(driver:Driver): Observable<Driver> {	
        return this.http.post<Driver>(this.url.rest  + '/tms/createDriver', driver , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    updateDriver(driver:Driver): Observable<Driver> {
        return this.http.put<Driver>(this.url.rest  + '/tms/updateDriver', driver , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    
    }

    deleteDriver(id: number): Observable<any> {
        return this.http.delete<any>(this.url.rest  + '/tms/deleteDriver/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    deleteJob(id: number) {
        return this.http.delete(this.url.rest  + '/tms/deleteDriverJob/' + id);
    }

    getDriverLicenseClasses(): Observable<{ license_classes: any }> { 
        return this.http.get<{ license_classes: any }>(this.url.rest  + '/tms/getDriverLicenseClasses', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getForkliftLicenceClasses(): Observable<{ license_classes: any }> { 
        return this.http.get<{ license_classes: any }>(this.url.rest  + '/tms/getForkliftLicenceClasses', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getStates(): Observable<{ states: State[] }> { 
        return this.http.get<{ states: State[] }>(this.url.rest  + '/tms/getStates', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getDriverStandards(): Observable<any[]> { 
        return this.http.get<any[]>(this.url.rest  + '/tms/getDriverStandards', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getDriverSubRoles(): Observable<any[]> { 
        return this.http.get<any[]>(this.url.rest  + '/tms/getDriverSubRoles', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }
    

    updateDriverPassword(password: Password): Observable<Password> {
        return this.http.put<Password>(this.url.rest  + '/tms/updateDriverPassword', password , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            ) 
    }

    getJobs(id: number): Observable<DriverJob[]> { 
        return this.http.get<DriverJob[]>(this.url.rest  + '/tms/getJobs/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }
    
    getJobById(id: number): Observable<DriverJob> { 
        return this.http.get<DriverJob>(this.url.rest  + '/tms/getJobById/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }
    
    getJobsByDriverId(driverId: number): Observable<DriverJob[]> { 
        return this.http.get<DriverJob[]>(this.url.rest  + '/tms/getJobsByDriverId/' + driverId, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getLocationByDriverId(driverId: number): Observable<any[]> { 
        return this.http.get<any[]>(this.url.rest  + '/tms/getLocationByDriverId/' + driverId, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getDriverFiles(): Observable<any[]> { 
        return this.http.get<any[]>(this.url.rest  + '/tms/getDriverFiles', this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getUnverifiedDriverFilesByDriverId(id: number): Observable<DriverFile[]> { 
        return this.http.get<DriverFile[]>(this.url.rest  + '/tms/getUnverifiedDriverFilesByDriverId/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getVerifiedDriverFilesByDriverId(id: number): Observable<DriverFile[]> { 
        return this.http.get<DriverFile[]>(this.url.rest  + '/tms/getVerifiedDriverFilesByDriverId/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    getDriverFilesByDriverId(id: number): Observable<DriverFile[]> { 
        return this.http.get<DriverFile[]>(this.url.rest  + '/tms/getDriverFilesByDriverId/' + id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    verifyDriverFile(driverFile: DriverFile): Observable<any> {
        return this.http.post<any>(this.url.rest  + '/tms/verifyDriverFile', driverFile , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    updateDriverFileView(driverFile: DriverFile): Observable<DriverFile> {
        return this.http.post<DriverFile>(this.url.rest  + '/tms/updateDriverFileView', driverFile , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )
    }

    updateDriverFile(driverfile: DriverFile): Observable<DriverFile> {
        return this.http.post<DriverFile>(this.url.rest  + '/tms/updateDriverFile', driverfile , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    deleteDriverFile(id: number, created_id: number, driver_user_id: number): Observable<any> {
        return this.http.delete<any>(this.url.rest  + '/tms/deleteDriverFile/' + id + '/' + created_id + '/' + driver_user_id, this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )    }

    createDriverFile(driverfile: DriverFile): Observable<DriverFile> {    
        return this.http.post<DriverFile>(this.url.rest  + '/tms/createDriverFile', driverfile , this.httpOptions)
            .pipe(
                retry(1),
                catchError(this.handleError)
            )   
        
        }

    getDocumentUploadTask(id: number): Observable<DriverFile[]> { 
    return this.http.get<DriverFile[]>(this.url.rest  + '/tms/getDocumentUploadTask/' + id, this.httpOptions)
        .pipe(
            retry(1),
            catchError(this.handleError)
        )    }

    // Error handling
    handleError(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
    }

}